export default __webpack_public_path__ + "src/assets/kintone_plugin/aintone_kintone_plugin.zip";